import { render, staticRenderFns } from "./ModuleChat.vue?vue&type=template&id=4177290c&scoped=true&lang=pug&"
import script from "./ModuleChat.vue?vue&type=script&lang=js&"
export * from "./ModuleChat.vue?vue&type=script&lang=js&"
import style0 from "./ModuleChat.vue?vue&type=style&index=0&id=4177290c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4177290c",
  null
  
)

export default component.exports